<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">

                <div class="   base-header__container ">
                    <div class="  d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            Европска ознака законодавства
                        </h1>
                    </div>
                </div>
            </div>
        </section>


        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec p-4">
                <div class="static-page-text">


                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">Јединствена европска ознака законодавства (ELI) је
                        систем који обезбеђује да законодавство буде доступно на интернету у
                        стандардизованом формату, тако да се актима може приступити и они се могу
                        размењивати и користити преко граница. ELI се користи за идентификацију прописа
                        јединственом ознаком која је препознатљива, читљива и разумљива за људе и машине
                        (компјутере) и која је усклађена с постојећим технолошким стандардима.</p>
                    <p class="auto-style20">Имплементација ELI ознаке у национална законодавства
                        иницирана је Закључцима Савета Европске уније о европском идентификатору
                        законодавства (ELI) (2017/C 441/05) од 6. новембра 2017. године.</p>
                    <p class="auto-style20">У Правно-информациони систем Републике Србије уведен
                        је ELI (3 стуба), и то код свих аката објављених у законодавном делу службених
                        гласила и свих аката објављених у бази Регистар.</p>
                    <p class="auto-style20">Увођење ELI- ја има за циљеве:</p>
                    <p class="auto-style20">- подизање видљивости и препознатљивости
                        Правно-информационог система Републике Србије на националном и интернационалном
                        (првенствено европском) нивоу,</p>
                    <p class="auto-style20">- лакши и бржи приступ прописима са аспекта
                        корисника,</p>
                    <p class="auto-style20">- омогућавање успостављања хармонизоване везе између
                        прописа Републике Србије (у перспективи и везе између прописа Републике Србије
                        са прописима ЕУ), и</p>
                    <p class="auto-style20">- стварање бржег и ефикаснијег система претраге и
                        начина размене података доступних јавности (коришћењем ELI идентификатора).</p>
                    <p class="auto-style20">На веб-сајту EUR-Lex &nbsp;у мају 2019. године отворена је
                        посебна страна посвећена Србији – имплементацији ELI-ja у Правно-информационом
                        систему Републике Србије, &nbsp;у делу <em>ELI implementation overview.</em></p>
                    <p class="auto-style21"><span class="auto-style3"><span class="auto-style5">Линк ка наведeној страни
                                је:
                            </span>
                            <a href="https://eur-lex.europa.eu/eli-register/serbia.html" target="_blank">
                                <span
                                    class="auto-style5">https://eur-lex.europa.eu/eli-register/serbia.html</span></a></span><span
                            class="auto-style6">.</span>
                    </p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style16"><span class="auto-style5">Контакт за детаљније информације:
                        </span>
                        <a href="mailto:eli@slglasnik.com"><span class="auto-style5">eli@slglasnik.com</span></a><span
                            class="auto-style5">.</span>
                    </p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style17">Основе програмског решења за имплементацију ELI-ја у
                        Правно-информациони систем Републике Србије</p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style17"><em>I стуб</em></p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">Приликом дефинисања ELI HTTP URI шеме, пратећи
                        смернице ELI <em>Task force</em>-а, посебна пажња је посвећена креирању јасних и
                        прецизних идентификатора који су блиски начину на који се законодавство цитира у
                        Србији, као и да идентификатори буду сачињени од компоненти које ће бити
                        „отпорне“ на проток времена и са јасном хијерархијом компонената.
                    </p>
                    <p class="auto-style20">Имплементирана основна ELI HTTP URI шема је:</p>
                    <p class="auto-style21"><span class="auto-style3"><span
                                class="auto-style5">http://www.pravno-informacioni-sistem.rs/eli/{nivo}/{vrsta_glasila}/{donosilac}/{vrsta_dokumenta}/{godina}/{broj}/{redni_broj}/</span></span>
                    </p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">&nbsp;</p>
                    <table cellpadding="0" cellspacing="0" class="auto-style9" style="width: 100%">
                        <tbody class="auto-style2">
                            <tr>
                                <td valign="top" width="302" class="auto-style22">
                                    <p class="auto-style23">Компонента</p>
                                </td>
                                <td valign="top" class="auto-style22">
                                    <p class="auto-style23">Значење</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">eli</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Информација о томе да је у питању ЕLI
                                        акта</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">nivo</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Показатељ да ли је у питању републичко
                                        или друго службено гласило. Тренутно, у складу са законским решењем,
                                        у Правно-информационом систему Републике Србије објављују само
                                        републички прописи и други акти, тако да је компонента код свих
                                        аката {rep} , али је програмским решењем створена могућност и за
                                        објављивање прописа другог нивоа (нпр. локална самоуправа).
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">vrsta_glasila</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Показатељ да ли је акт објављен у
                                        “Службеном гласнику РС {sgrs}, “Службеном гласнику Републике Србије
                                        - Међународни уговори” {mu} или “Службеном гласнику Републике Србије
                                        - Просветни гласник” {pg}</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">donosilac</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Информација ко је доносилац акта</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">vrsta_dokumenta</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Информација о врсти документа</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">godina</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Година службеног гласила у коме је пропис
                                        објављен</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">broj</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Број службеног гласила у коме је пропис
                                        објављен</p>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="302" class="auto-style10">
                                    <p class="auto-style19">redni broj</p>
                                </td>
                                <td valign="top" class="auto-style10">
                                    <p class="auto-style19">Редни број врсте акта коју је донео
                                        одређени доносилац у одређеном броју </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20"><em>Пример:
                        </em>
                    </p>
                    <p class="auto-style20"><em>Закон о објављивању закона и других прописа и аката
                            (“Службени гласник РС”, број 45/13)</em></p>
                    <p class="auto-style20">
                        <a href="http://www.pravno-informacioni-sistem.rs/eli/rep/sgrs/skupstina/zakon/2013/45/4">
                            <em>http://www.pravno-informacioni-sistem.rs/eli/rep/sgrs/skupstina/zakon/2013/45/4</em></a>
                    </p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">Имплементирано програмско решење омогућило је да се
                        основна URI шема може надоградити и другим компонентама, као што су:</p>
                    <p class="auto-style20">/sg - за приказ акта у облику у ком је објављен у
                        службеном гласилу;</p>
                    <p class="auto-style20"><em>Пример:</em></p>
                    <p class="auto-style21">&nbsp;<span class="auto-style3"><a
                                href="http://www.pravno-informacioni-sistem.rs/eli/rep/sgrs/skupstina/zakon/2013/45/4"><span
                                    class="auto-style5"><em>http://www.pravno-informacioni-sistem.rs/eli/rep/sgrs/skupstina/zakon/2013/45/4</em></span></a><span
                                class="auto-style5"><em>/sg</em></span></span></p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">/reg - за приказ акта у оквиру базе Регистар, у којој
                        се објављују основни и пречишћени текстови прописа (званично и незванично);</p>
                    <p class="auto-style20"><em>Пример:</em></p>
                    <p class="auto-style21">&nbsp;<span class="auto-style3"><a
                                href="http://www.pravno-informacioni-sistem.rs/eli/rep/sgrs/skupstina/zakon/2013/45/4"><span
                                    class="auto-style5"><em>http://www.pravno-informacioni-sistem.rs/eli/rep/sgrs/skupstina/zakon/2013/45/4</em></span></a><span
                                class="auto-style5"><em>/reg</em></span></span></p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">/{tačka_u_vremenu} у облику ГГГГММДД - за приказ
                        верзије пречишћеног текста прописа (из базе Регистар) који се примењивао у
                        одређеној тачки у времену. Чување верзија пречишћених текстова омогућено је у
                        Правно-информационом систему Републике Србије од друге половине 2016. године,
                        тако да ова компонента има функцију само код прописа код којих постоје текстови
                        верзија пречишћеног текста;</p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">/{jezik} - иако се, у овом моменту, сви акти
                        објављују на српском језику, изабрано је да се може у URI шеми додати компонента
                        „/srb” ради ознаке језика правног ресурса и омогућено да језик правног ресурса
                        може бити и енглески, ако у будућности буде потребе за објављивањем прописа на
                        више језика;</p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">/{format} - за приказ акта у PDF или HTML формату.</p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style17"><em>II стуб</em></p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">Имајући у виду да је база Регистар централна база
                        Правно-информационог система Републике Србије, у којој се објављују основни и
                        пречишћени текстови прописа и која је, у складу са законским решењем, бесплатно
                        доступна свим корисницима интернета (што је у складу са <em>open data</em> филозофијом
                        ELI-ја), сви акти у наведеној бази повезани су службеним гласилима у којима су
                        објављени основни текстови прописа, као и све измене, допуне и исправке, и
                        обрнуто. Сви републички прописи у наведеној бази имају поље “О акту” које садржи
                        основне податке о пропису и то:</p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">ELI URI шема;&nbsp;
                        </span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Врста документа;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Назив документа</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Датум усвајања основног текста;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Датум објављивања основног текста;
                        </span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Датум ступања на снагу основог текста;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Датум почетка примене основног текста;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Датум ступања на снагу верзије
                            пречишћеног текста;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Датум почетка примене верзије
                            пречишћеног текста;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Опис (уредничка напомена);</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">Издавач: Службени гласник д.о.о.</span>
                    </p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">Имплементирано програмско решење омогућило је и
                        повезивање прописа у оквиру Правно-информационог система Републике Србије, преко
                        прописа у бази Регистар, и то:</p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са прописима на које одређени акт
                            утиче;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са прописима којима је одређени акт
                            измењен (други пропис који мења пропис);</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са прописима који представљају основ за
                            доношење одређеног акта;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са прописима којима акт представља
                            основ за доношење (подзаконски акти);</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са повезаним прописима (прописи на које
                            се позива правном акту);</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">прописи са којима је одређени акт
                            повезан;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са правним претходником;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са правним следбеником;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са свим изменама и допунама и
                            исправкама документа;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са пречишћеним текстом прописа;</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са уставносудским одлукама које утичу
                            на пропис (у HTML-у и PDF-у);</span>
                    </p>
                    <p class="auto-style16"><span class="auto-style5">−&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span class="auto-style5">са директивама ЕУ - имајући у виду да
                            Република Србија још увек није чланица Европске уније, имплементирано програмско
                            решење омогућило је да, у будућности, када се јави потреба, прописи Републике
                            Србије буду повезани са директивама ЕУ.</span>
                    </p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style17"><em>III стуб</em></p>
                    <p class="auto-style20">&nbsp;</p>
                    <p class="auto-style20">Метаподаци који се користе за описивање ресурса
                        „кодирани“ у складу са W3C препоруком „RDF-a у XHTML-u: Синтакса и
                        Процесуирање“, доступне на
                        https://www.w3.org/TR/2008/REC-rdfa-syntax-20081014/#s_Syntax_overview. </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: "EliOverview",
    data() {
        return {
            loaded: false,

            baseApiUrl: window.env.VUE_APP_API_URL_PRODUCTION,

            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    mounted() {
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style scoped></style>
